import { BasketRow, BasketRowsGroup } from 'graphql-api/baskets-api-interfaces';

export const extractBasketRows = (groups: BasketRowsGroup[]): BasketRow[] => {
  return groups
    .map((childGroup) => {
      if (childGroup.rows) {
        return childGroup.rows;
      }
      return childGroup.groups
        ? extractBasketRows(childGroup.groups)
        : extractBasketRows([]);
    })
    .flat();
};
